(ns ui.editors.file.upload
  (:require [common.localization :as loc]
            [potpuri.core :as potpuri]
            [ui.util :as uu]))

(defn indicators
  [local-atom]
  [:div
   {:class "flex flex-col pl-2 pr-4 leading-6 gap-2"}
   (->> @local-atom
        :uploading
        (remove (fn [[_token meta]]
                  (= (:status meta) :complete)))
        (map
         (fn [[token meta]]
           (let [{:keys [file-name progress status]} meta]
             [:div
              {:key        (str "uploading-indicator-" token)
               :class-name (uu/cm "upload-indicator" status)}
              (when (some #{status} [:error :uploading])
                (let [progress (or progress 0.0)]
                  [:span.upload-indicator__bar
                   {:style {:width (str (uu/round progress 2) "%")}}]))
              [:div
               {:class-name "grid grid-cols-10 gap-4 px-4 z-[1]"}
               [:div
                {:class-name "col-span-5"}
                [:label.upload-indicator__label
                 [:span
                  (case status
                    :uploading (loc/tr :file-upload-indicator-label)
                    :error (loc/tr :file-upload-error-label)
                    "")]]]
               [:div
                {:class-name "col-span-5 text-right"}
                [:span
                 {:class "flex items-center justify-end"}
                 (when (some #{status} [:error :uploading])
                   (let [progress (or progress 0.0)]
                     [:span
                      {:class "block pr-3 text-base-light-text text-xs"}
                      (str (uu/round progress 2) "%")]))
                 (when (not= :uploading status)
                   [:i.fas.fa-times-circle
                    {:class "text-danger-light-text block pr-1"
                     :on-click (fn [_]
                                 (swap! local-atom potpuri/dissoc-in [:uploading token]))}])]]
               [:div
                {:class-name "col-span-10"}
                [:span 
                 {:class "text-xs"}
                 file-name]]]])))
        (doall))])
